import { Dispatch, SetStateAction } from "react";
import NextItem from "../components/NextItem";
import BackButton from "../components/BackButton";
import { MainImage } from "../workDetailPage/WorkMainImage";
import Navigator from '../components/Navigation';
import { WorkFullImage } from "../workDetailPage/WorkFullImage";
import { ArticleTextSection } from "../articleDetailPage/ArticleTextSection"
import { ArticleTitle } from "../articleDetailPage/ArticleTitle";
import { ArticleMainImage } from "../articleDetailPage/ArticleMainImage";
import image1 from '../image/articles/creative5-2.webp';
import article2Thumbnail from '../image/articles/article2_1.webp';
import ProtectedPage from "../components/ProtectedPage";
import { hashPasswordsFromEnv } from "../utils/passwordUtils";
import ArticleImageLayout from "../articleDetailPage/ArticleImageLayout";
import '../style.css';
import { Wavedivider } from "../components/Wavedivider";
import YouTubeEmbed from "../components/YouTubeEmbed";
import { CalloutLink } from "../components/CalloutLink";
import { useMetaTags } from '../utils/useMetaTags';

function Creative2(props: {
    activeNav: number, 
    setActiveNav: Dispatch<SetStateAction<number>>,
  }) {
    const hashedPasswords = hashPasswordsFromEnv(
      process.env.REACT_APP_CREATIVE2_PASSWORDS
    );
      const images1 = [image1]; // 1개 이미지
      
      useMetaTags({
        title: '2024 당근 광고실 하반기 레크레이션 - Lynkim',
        description: '플레이샵 게임',
        image: '/ogimage.png',
      });
      
      return (
        <>
         {/* <ProtectedPage password={hashedPasswords} description="게임의 제목: 당근마을 ㅇㅇㅇ을 찾아라"> */}
              <Navigator activeNav={props.activeNav} setActiveNav={props.setActiveNav} />
              <div className='fadeIn '>
                  <ArticleTitle
                      title={'2024 당근 광고실 하반기 레크레이션'}
                      titleEn={'2024 Daangn Ads Team H2 Recreation'}
                      description={'플레이샵 게임'}
                      descriptionEn={'Playshop games'}
                      category={'creative'}
                      date={'2024.11.07.'} />
              </div>
              <Wavedivider />
              <ArticleTextSection
                  description={<div>
                      <CalloutLink href="https://www.figma.com/deck/cSuiDaNrHbAoJiYBi49jbh/%EB%8B%B9%EA%B7%BC-2024-%ED%95%98%EB%B0%98%EA%B8%B0-%EA%B4%91%EA%B3%A0%EC%8B%A4-%EB%A0%88%ED%81%AC%EB%A0%88%EC%9D%B4%EC%85%98?node-id=1-119&viewport=16%2C36%2C0.5&t=YLABhWK7cm8iApGr-1&scaling=min-zoom&content-scaling=fixed&page-id=0%3A1">
                          놀러가요 광고실 | 당근마을 광고왕을 찾아라!
                      </CalloutLink>
                  </div>} />
              <div className='articleLayout'>
                  <ArticleImageLayout images={images1} />
              
              
            </div>
          <BackButton />
       
        </>
      )
  }
  
  export default Creative2;
